import { render, staticRenderFns } from "./ChinaUnion.vue?vue&type=template&id=30efa1e9&"
import script from "./ChinaUnion.vue?vue&type=script&lang=js&"
export * from "./ChinaUnion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports